<template>
  <naj-modal
    ref="modal"
    :title="local.attachments.title"
    :width="1500"
    :footer="true"
    @onClose="closeModal"
  >
    <v-form ref="requestReasonForm">
      <v-row>
        <v-col
          v-if="hasAttachment"
          cols="3"
        >
          <attachment-card
            :file="{ ...uploadedFile }"
            :show-delete-button="true"
            @deleteAttachment="showDeleteConfirmationModal"
          ></attachment-card>
        </v-col>
        <v-col
          v-else
          class="attachment"
          cols="12"
        >
          <load-local-attachment
            :max-file-size="5"
            @fileSelected="localAttachmentSelected"
          >
          </load-local-attachment>
        </v-col>
      </v-row>
    </v-form>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <naj-button
        :disabled="!hasAttachment"
        @click="handleAddReason"
      >
        {{ local.common.add }}
      </naj-button>
    </template>

    <naj-confirmation
      :show-modal="showDeleteModal"
      color="error"
      :title="local.common.removeConfirmation"
      :message="local.common.removeConfirmationMessage"
      :ok-btn-label="local.common.remove"
      @ok="confirmDeleteAttachment"
      @cancel="cancelDeleteAttachment"
    ></naj-confirmation>
  </naj-modal>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions } = createNamespacedHelpers('CasesModule');

import LoadLocalAttachment from '../attachment-modal/load-local-attachment';
import AttachmentCard from '@/components/shared/attachment-modal/attachment-card';

export default {
  name: 'RequestReasonModal',
  components: {
    LoadLocalAttachment,
    AttachmentCard,
  },
  props: ['modalVisibility'],
  data() {
    return {
      reasonCounter: 256,
      loading: false,
      showDeleteModal: false,
      selectedFile: null,
    };
  },
  computed: {
    hasAttachment() {
      return !!this.selectedFile;
    },
    uploadedFile() {
      if (this.hasAttachment) {
        return {
          name: this.selectedFile.fileName,
          attachmentKey: this.selectedFile.attachmentKey,
        };
      }
      return {};
    },
  },
  watch: {
    modalVisibility(newValue) {
      this.resetForm();
      if (newValue) {
        this.$refs.modal.show();
      } else {
        this.$refs.modal.close();
      }
    },
  },
  mounted() {
  },
  methods: {
    ...mapActions(['uploadAttachment']),
    closeModal() {
      this.$emit('onClose');
      this.resetForm();
    },
    handleAddReason() {
      this.$refs.requestReasonForm.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.$emit('addRequestReasonAttachment', {
              sharePointId: (this.selectedFile || {}).sharePointId,
              sharePointFileName: (this.selectedFile || {}).fileName,
              fileType: (this.selectedFile || {}).fileType,
              fileTypeId: (this.selectedFile || {}).fileTypeId,
              extension: (this.selectedFile || {}).extension,
            });
            this.closeModal();
          }
        });
    },
    resetForm() {
      if (this.$refs.requestReasonForm) {
        this.$refs.requestReasonForm.$validator.reset();
      }
      this.selectedFile = null;
    },
    showDeleteConfirmationModal() {
      this.showDeleteModal = true;
    },
    cancelDeleteAttachment() {
      this.showDeleteModal = false;
    },
    confirmDeleteAttachment() {
      this.selectedFile = null;
      this.cancelDeleteAttachment();
    },
    localAttachmentSelected({ selectedAttachment: attachment, selectedAttachmentKey }) {
      this.loading = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');
        this.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            this.$set(this, 'selectedFile', {
              attachement: b64,
              fileName: attachment.name,
              fileType: attachment.fileObject.type,
              fileTypeId: attachment.fileType,
              sharePointId: data,
              extension: attachment.extension,
              fileCategory: attachment.category,
              attachmentKey: selectedAttachmentKey,
            });
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };
      reader.readAsDataURL(attachment.fileObject);
    },
  },
};
</script>
